import { useState } from "react";
import { useMutation } from "@stadium/services/apollo-client";

import { populateBundleItems } from "@graphql/mutations/kit/populate-kit";

const usePopulateKitItems = () => {
  const [showItemAddedMsg, setShowItemAddedMsg] = useState(false);

  const [populateItems, { data, loading }] = useMutation(populateBundleItems);

  const updateItemInCart = (products = [], bundleNumber) => {
    const payload = { bundleNumber, bundleProductAttributes: products };

    return populateItems({
      variables: {
        input: payload,
      },
    });
  };

  return {
    updateItemInCart,
    data,
    loading,
    setShowItemAddedMsg,
    showItemAddedMsg,
  };
};

export default usePopulateKitItems;
